import React, { memo, useCallback } from "react";
import { ReactionType } from "gql/graphql";
import { Avatar, AvatarGroup } from "@chakra-ui/react";
import {
  ReactionThumbsUpColorIcon,
  ReactionHeartColorIcon,
  ReactionThumbsDownColorIcon,
  ReactionLaughingColorIcon,
  ReactionSurpriseColorIcon,
} from "modules/icons";

interface IProps {
  reactionTypes: ReactionType[];
  spacing?: number;
}

const REACTION_BOX_SIZE = 5;

const ReactionsAvatarGroup = ({ reactionTypes, spacing = -0.5 }: IProps) => {
  const hasType = useCallback(
    (type: ReactionType) =>
      reactionTypes.some((reactionType) => reactionType === type),
    [reactionTypes],
  );

  return (
    <AvatarGroup spacing={spacing}>
      {hasType(ReactionType.Like) && (
        <Avatar
          icon={<ReactionThumbsUpColorIcon boxSize={REACTION_BOX_SIZE} />}
          size="2xs"
          zIndex={1}
        />
      )}
      {hasType(ReactionType.Heart) && (
        <Avatar
          icon={<ReactionHeartColorIcon boxSize={REACTION_BOX_SIZE} />}
          size="2xs"
          zIndex={2}
        />
      )}
      {hasType(ReactionType.Dislike) && (
        <Avatar
          icon={<ReactionThumbsDownColorIcon boxSize={REACTION_BOX_SIZE} />}
          size="2xs"
          zIndex={3}
        />
      )}
      {hasType(ReactionType.Laughing) && (
        <Avatar
          icon={<ReactionLaughingColorIcon boxSize={REACTION_BOX_SIZE} />}
          size="2xs"
          zIndex={4}
        />
      )}
      {hasType(ReactionType.Surprise) && (
        <Avatar
          icon={<ReactionSurpriseColorIcon boxSize={REACTION_BOX_SIZE} />}
          size="2xs"
          zIndex={5}
        />
      )}
    </AvatarGroup>
  );
};

export default memo(ReactionsAvatarGroup);
